module.exports = __webpack_public_path__ + "img/index4.3e5c8e5d.png";